import { jsx as _jsx } from "react/jsx-runtime";
import { Platform } from "react-native";
import { WebView } from "react-native-webview";
/**
 * Displays terms and conditions & privacy policy from ouitherapeutics.com
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-146}
 */ export var TermsAndPrivacy = function() {
    return Platform.OS === 'web' ? /*#__PURE__*/ _jsx("iframe", {
        src: "https://ouitherapeutics.com/terms-and-privacy/",
        style: {
            flex: 1
        }
    }) : /*#__PURE__*/ _jsx(WebView, {
        source: {
            uri: 'https://ouitherapeutics.com/terms-and-privacy/'
        }
    });
};
